import './webOSTV';

// the webOSTV library adds a webOS object to the window, so we will export it here
// @ts-ignore
export default window.webOS;